/* src/app/modules/supportTickets/tickets-dialogs.css */
.sp-dlg .cf-dlg-icon {
  background: #eef0f5;
}
.sp-dlg .cf-dlg-icon mat-icon {
  color: #1e2235;
}
.sp-dlg .cf-dlg-icon--green {
  background: rgba(22, 163, 74, 0.1) !important;
}
.sp-dlg .cf-dlg-icon--green mat-icon {
  color: #15803d !important;
}
.sp-dlg .cf-dlg-btn-primary {
  background-color: #1e2235 !important;
  color: #ffffff !important;
}
.sp-dlg .cf-dlg-btn-primary[disabled] {
  background-color: #e5e7eb !important;
  color: #9ca3af !important;
}
.sp-dlg .cf-dlg-btn-primary mat-icon,
.sp-dlg .cf-dlg-btn-secondary mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 4px;
  vertical-align: middle;
}
.sp-dlg-heading {
  min-width: 0;
  padding-right: 32px;
}
.sp-dlg .cf-dlg-subtitle {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}
.sp-field-label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}
.sp-priority-picker {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 18px;
}
.sp-priority-option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #ffffff;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.sp-priority-option:hover {
  border-color: #cbd5e1;
}
.sp-priority-option__dot,
.sp-dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}
.sp-priority-option--low .sp-priority-option__dot,
.sp-dot--low {
  background: #94a3b8;
}
.sp-priority-option--medium .sp-priority-option__dot,
.sp-dot--medium {
  background: #f59e0b;
}
.sp-priority-option--high .sp-priority-option__dot,
.sp-dot--high {
  background: #dc2626;
}
.sp-priority-option--active {
  border-color: #1e2235;
  background: #f4f5f9;
  color: #1e2235;
  box-shadow: inset 0 0 0 1px #1e2235;
}
.sp-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 1px 9px;
  border-radius: 999px;
  background: rgba(217, 119, 6, 0.12);
  color: #b45309;
  font-size: 11px;
  font-weight: 700;
}
.sp-chip--resolved {
  background: rgba(22, 163, 74, 0.12);
  color: #15803d;
}
.sp-chip--muted {
  background: #f3f4f6;
  color: #4b5563;
  font-weight: 600;
}
.sp-thread {
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-height: 52vh;
  overflow-y: auto;
  background: #f7f8fa;
}
.sp-msg {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  max-width: 88%;
}
.sp-msg--support {
  align-self: flex-end;
  flex-direction: row-reverse;
}
.sp-msg__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e5e7eb;
  color: #374151;
  font-size: 13px;
  font-weight: 700;
}
.sp-msg--support .sp-msg__avatar {
  background: #1e2235;
  color: #ffffff;
}
.sp-msg__bubble {
  min-width: 0;
  padding: 10px 14px;
  border-radius: 14px 14px 14px 4px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
}
.sp-msg--support .sp-msg__bubble {
  border-radius: 14px 14px 4px 14px;
  background: #1e2235;
  border-color: #1e2235;
  color: #ffffff;
}
.sp-msg__head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 12px;
}
.sp-msg__head strong {
  font-weight: 700;
}
.sp-msg__head span {
  color: #9ca3af;
}
.sp-msg--support .sp-msg__head span {
  color: rgba(255, 255, 255, 0.6);
}
.sp-msg__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.sp-resolved-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #15803d;
}
.sp-resolved-note mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.sp-reply {
  padding: 12px 24px 0;
  border-top: 1px solid #e5e7eb;
}
.sp-reply textarea {
  width: 100%;
  resize: vertical;
  min-height: 72px;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font: inherit;
  font-size: 14px;
  color: #1a1d23;
  outline: none;
}
.sp-reply textarea:focus {
  border-color: #1e2235;
  box-shadow: 0 0 0 3px rgba(30, 34, 53, 0.08);
}
.sp-footer-spacer {
  flex: 1;
}
.sp-resolve-btn {
  color: #15803d !important;
  border-color: rgba(22, 163, 74, 0.4) !important;
}
.ex-error-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(220, 38, 38, 0.08);
  color: #b91c1c;
  font-size: 14px;
}
.sp-msg__avatar mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.sp-msg__role {
  margin-bottom: 2px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
}
.sp-msg--support .sp-msg__role {
  color: rgba(255, 255, 255, 0.7);
}
.sp-legend {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
}
.sp-legend span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.sp-legend__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.sp-legend__dot--client {
  background: #ffffff;
  border: 1px solid #d1d5db;
}
.sp-legend__dot--support {
  background: #1e2235;
}
/*# sourceMappingURL=tickets-dialogs.css.map */
